export const QUICK_FILTER_DATA = (
  setFilter,
  draftCount,
  createdInLast30DaysCount
) => {
  const date = new Date();
  return [
    {
      label: "Draft",
      value: draftCount,
      onClick: () =>
        setFilter({
          filterBy: "status =",
          filterValue: "draft",
        }),
    },
    {
      label: "Last 30 days",
      value: createdInLast30DaysCount,
      onClick: () =>
        setFilter({
          filterBy: "created_at>",
          filterValue: new Date(
            date.setDate(date.getDate() - 30)
          ).toUTCString(),
        }),
    },
  ];
};
